import { render } from "./FTranslation.vue?vue&type=template&id=8b215a90"
import script from "./FTranslation.vue?vue&type=script&lang=js"
export * from "./FTranslation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__